<template>
    <div>
         <h1 class="display-3 ma-5 pa-5 indigo darken-1 white--text rounded-tl-xl" >Gestão</h1>
        <v-divider class="mb-6"></v-divider>

<v-card class="ma-5 pa-5">
    <v-layout row justify-center >

        
        <v-flex xs4 >

            <v-text-field type="date" label="Data inicial" v-model="dates.ini" prepend-icon="fa fa-calendar" ></v-text-field>
            <v-text-field type="date" label="Data final" v-model="dates.fim" prepend-icon="fa fa-calendar" ></v-text-field>
           
             <!-- <v-menu
                ref="menu"
               
                :close-on-content-click="false"
                :return-value.sync="dates"
                transition="scale-transition"
                offset-y
                min-width="290px"
             >
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dates"
                label="Selecione a data"
                prepend-icon="fa fa-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>

            </template>
        
            <v-date-picker  v-model="dates" locale="pt-BR" range>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn text color="primary" @click="recarregarData() ">OK</v-btn>
            </v-date-picker>
        </v-menu> -->



            <p class="grey--text darken-2" >Por padrão é carregado 10 dias de relatório</p>           
            </v-flex>
            
        </v-layout>
        <v-row justify="center">
             <v-col cols="8">
                <v-btn block :disabled="!dates.ini || !dates.fim" @click="recarregarData" class="green lighten-2 white--text" >Recarregar com datas</v-btn>
            </v-col>
            
        <v-col cols="8">
                <v-select
                prepend-inner-icon="mdi-face"
            :items="barbeiros"
            item-text="nome"
            item-value="id"
            v-model="barbeiroFiltrado"
            label="Filtre por barbeiro"
            @change="filtrarPorBarbeiro"
            dense
            ></v-select>

        </v-col>

        <v-col cols="8" >
            <v-btn block :disabled="!usarBarbeiro || !usarData" @click="limparFiltro">Limpar filtros</v-btn>
        </v-col>
        </v-row>
        
    </v-card>
 
    
        <v-card class="pa-5 ma-5">
            <div class="grey lighten-3" >

            <v-card-title class="display-2" >Receita por barbeiro</v-card-title>
            </div>
            <v-divider class="mb-5" ></v-divider>
            <pie-chart :data="receitaPorBarbeiroChart"></pie-chart>
 

            <v-list>
            <v-list-item
               v-for="item in receitaPorBarbeiro" 
                :key="item.barbeiro"
            >
                <v-list-item-icon>
                <v-icon
                    color="blue"
                >
                    mdi-account
                </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                <v-list-item-title v-text="item.barbeiro"></v-list-item-title>
                <div>R$ {{item.receita.toLocaleString()}}</div>
                </v-list-item-content>

              
            </v-list-item>
            </v-list>
        </v-card>

        <v-card class="pa-5 ma-5">
            <div class="grey lighten-3" >

            <v-card-title class="display-2" >Serviços mais vendidos</v-card-title>
            </div>
            <v-divider class="mb-5" ></v-divider>
            <v-list>
                <v-list-item class="grey lighten-3 ma-1" v-for="item in receitaPorServico" :key="item.servico" >
                    
                     <v-list-item-icon>
                        <v-icon size="50" class="indigo--text" >fa fa-hand-scissors</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title  v-text="item.servico"></v-list-item-title>
                        
                    </v-list-item-content>
                    <v-list-item-content class="px-3 indigo lighten-5 rounded-xl" >
                        <v-list-item-title class="display-1"  v-text="'R$ ' + item.receita.toLocaleString()"></v-list-item-title>
                        <v-list-item-title v-text="'Quantidade: ' + item.quantidade"></v-list-item-title>
                    </v-list-item-content>
                    
                </v-list-item>
                
            </v-list>
        </v-card>

        <v-card class="pa-5 ma-5">
            <div class="grey lighten-3" >

            <v-card-title class="display-2" >Receita por clientes (15 maiores)</v-card-title>
            </div>
            <v-divider class="mb-5" ></v-divider>
            <v-list>
                <v-list-item v-for="item in receitaPorUsuario" :key="item.email" class="grey lighten-3 ma-1" >
                    
                     <v-list-item-icon>
                        <v-icon size="50" class="indigo--text" >fa fa-user</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="indigo ma-1 pa-3 white--text rounded-xl" >
                        <v-list-item-title v-text="item.nome"></v-list-item-title>
                        <v-list-item-title v-text="item.telefone"></v-list-item-title>
                        <v-list-item-title v-text="item.email"></v-list-item-title>
                        
                    </v-list-item-content >
                    <v-list-item-content class="px-3 indigo lighten-5 rounded-xl" >
                        <v-list-item-title class="display-1" v-text="'R$ ' + item.receita.toLocaleString()"></v-list-item-title>
                        <v-list-item-title v-text="'Quantidade: ' + item.quantidade"></v-list-item-title>
                    </v-list-item-content>
                    
                </v-list-item>
                
            </v-list>
        </v-card>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {refAgenda, refBarbeiros,refFuncoes} from '@/firebaseConfig'
    export default {
        data() {
            return {
                dates: {},
                usarData: false,
                usarBarbeiro: false,
                refAgenda: refAgenda,
                refBarbeiros: refBarbeiros,
                refFuncoes: refFuncoes,
                barbeiros: [],
                barbeiroFiltrado: '',
                receitaPorBarbeiro:[],
                receitaPorBarbeiroChart: [],
                listaAgenda: [],
                receitaPorServico: [],
                receitaPorUsuario: [],
            }
        },
        computed: {
         ...mapGetters(["getCurrentUser", "isUserAuth"]),
         diasMilliSeconds: function() {
             let diasRetornar = 10
             return (24 * 60 * 60 * 1000) * diasRetornar
         }

        },
        async created(){
            await this.carregarVendasPorBarbeiro();
            await this.carregarVendasPorServico();
            await this.carregarReceitaPorUsuario();
        },
        methods: {
            async limparFiltro(){
                this.usarBarbeiro = false
                this.usarData = false

                await this.carregarVendasPorBarbeiro();
                await this.carregarVendasPorServico();
                await this.carregarReceitaPorUsuario();
            },
            async filtrarPorBarbeiro(){
                this.limparDados()
                this.usarBarbeiro = true
                await this.carregarVendasPorBarbeiro();
                await this.carregarVendasPorServico();
                await this.carregarReceitaPorUsuario();
                //this.usarBarbeiro = false
            },
            async recarregarData(){
                // this.$refs.menu.save(this.dates)
                console.log(this.dates);
                this.limparDados()
                this.usarData = true
                await this.carregarVendasPorBarbeiro();
                await this.carregarVendasPorServico();
                await this.carregarReceitaPorUsuario();
            },
            
            limparDados(){
                this.barbeiros = []
                this.receitaPorBarbeir = []
                this.receitaPorBarbeiroChart = []
                this.listaAgenda = []
                this.receitaPorServico = []
                this.receitaPorUsuario = []
            },
           async carregarVendasPorBarbeiro(){
                await this.refBarbeiros.get().then((snap) => {
                    snap.forEach((bar)=>{
                        this.barbeiros.push({...bar.data()});
                        let item = bar.data()
                       // console.log(item.nome);
                       if(this.usarBarbeiro){
                           if(this.barbeiroFiltrado == item.id){

                               this.agruparPorBarbeiro(item);
                           }
                       }else{

                           this.agruparPorBarbeiro(item);
                       }
                
                    });
                   
                });
   
            },

            async agruparPorBarbeiro(item){
                let snap = []
                // let dataIn = new Date(this.dates[0]).getTime()
                // let dataFim = new Date(this.dates[1]).getTime()
                let dataIn = new Date(this.dates.ini).getTime()
                let dataFim = new Date(this.dates.fim).getTime()
                this.receitaPorBarbeiro = []
                if(this.usarData){
                    console.log(dataIn);
                    console.log(dataFim);
                    snap = await this.refAgenda.where("barbeiro.id","==",item.id)
                    .where("dataQuery", ">=", dataIn)
                    .where("dataQuery", "<=", dataFim)
                    .get();
                }else{               //  24h * 60m * 60 segundos * 1 mil = dias em miliseconds
                    
                    dataIn = new Date().getTime() - this.diasMilliSeconds
                    dataFim = new Date().getTime()

                    snap = await this.refAgenda.where("barbeiro.id","==",item.id)
                    .where("dataQuery", ">=", dataIn)
                    .where("dataQuery", "<=", dataFim)
                    .get();
                }
                const total = snap.docs.length;
                        let receita = 0;
                        snap.forEach((agenda)=>{
                            if(typeof agenda.data().servico != 'undefined'){
                                receita += parseFloat(agenda.data().servico.preco)
                                this.listaAgenda.push(agenda.data())
                            }   

                        });
                        this.receitaPorBarbeiro.push({
                            quantidade:  total,
                            receita:  receita,
                            barbeiro:  item.nome,
                        });
                        this.receitaPorBarbeiroChart.push([item.nome, receita])
                        this.receitaPorBarbeiro.sort((a,b) => a['receita'] > b['receita'] ? -1 : 1);

                    //console.log(this.receitaPorBarbeiro);
            },
           
        
        carregarVendasPorServico(){
            //console.log(this.listaAgenda);
            let servicos = []
            refFuncoes.get().then((snap) => {
                snap.forEach((item)=>{
                    servicos.push(item.data());

                    this.agruparPorServico(item.data(), this.listaAgenda);

                });
                //console.log(servicos);
                console.log(this.receitaPorServico);
                
                this.receitaPorServico.sort((a,b) => a['receita'] > b['receita'] ? -1 : 1);

            });
            
        },
        agruparPorServico(servico, listaAgenda){
            
            let valorTotal = 0;
            let quantidade = 0;
           //console.log(this.listaAgenda.length);
            listaAgenda.map((item)=>{
                //console.log("FOREACH");
               // console.log(item.servico.id);
                if(item.servico.id === servico.id){
                    valorTotal += parseFloat(item.servico.preco)
                    quantidade += 1
                   
                }
            });
            this.receitaPorServico.push({"quantidade": quantidade, "servico": servico.descricao, "receita": valorTotal})
        },

        carregarReceitaPorUsuario(){
            let emailsList = []
            //console.log("Agenda",this.listaAgenda);
            setTimeout(()=>{
            this.listaAgenda.forEach((agenda)=> {
                    emailsList.push(agenda.cliente.email)});
                let lista = ([...new Set(emailsList)]);

                lista.forEach(email => {
                    let quantidade = 0
                    let receita = 0
                    let userName = ''
                    let userTel = ''
                     this.listaAgenda.forEach((agenda)=> {
                        //emailsList.push(agenda.cliente.email)
                        if(agenda.cliente.email === email){
                            quantidade += 1
                            receita += parseFloat(agenda.servico.preco)
                            userName = agenda.cliente.nome
                            userTel = agenda.cliente.telefone
                        }
                    });
                    
                    this.receitaPorUsuario.push({quantidade: quantidade, receita: receita, nome: userName, telefone: userTel, email: email})
                    

                });
                this.receitaPorUsuario.sort((a,b) => a['receita'] > b['receita'] ? -1 : 1);
                this.receitaPorUsuario = this.receitaPorUsuario.slice(0, 15);
                //console.log(lista);
                //console.log(emailsList);
            }, 2000);
            
        }



        }
        
    }
</script>

<style lang="scss" scoped>

</style>